<template>
  <div class="modal-mask" role="dialog">
    <div class="overlay-mask">
      <div class="modal-dialog modal-lg">
        <div class="modal-content modal-edit-bg">
          <div class="modal-body">
            <div class="close_btn" v-on:click="CloseModal()"></div>
            <br />
            <!-- <h1>{{crps}}</h1> -->
            <div class="alert alert-dismissible" v-if="crps == 'Enrolled'">
              <strong>Thank you for pledging to Adopt-a-School in your community! Visit the Resources Page to access our Adopt-a-School resources.</strong>
            </div>
            <div class="alert alert-dismissible" v-if="crps == 'Declined'">
              <strong
                >No problem. If you change your mind you can always learn more and pick your CLTL Day from the Resource Page.</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["crps"],
  components: {},
  data() {
    return {
      isFormLoading: false,
      isModalShown: true,
      CovidReliefParticipantStatus: "",
    };
  },
  methods: {
    CloseModal() {
      this.$emit("CtlCovidReliefFeedbackResultModal");
    },
    SubmitCRPS() {
      var _this = this;
      _this.isFormLoading = true;
      axios
        .post(
          "/Account/CovidReliefParticipant",
          {
            response: this.CovidReliefParticipantStatus,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then(function (response) {
          if (response.data.isSuccess == true) {
            _this.isFormLoading = false;
            _this.CloseModal();
            // alert("Your feedback was saved.")
            localStorage.setItem(
              "covidReliefParticipantStatus",
              response.data.raw.covidReliefParticipantStatus
            );
            localStorage.setItem("isCovidReliefStatusChecked", "true");
          } else {
            _this.isFormLoading = false;
            localStorage.setItem("isCovidReliefStatusChecked", "true");
            alert("We got an Error on your request.");
            _this.CloseModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  created() {
    // get covid relief status
    // if enrolled, declined, show modal  = false
    // if remind, , show modal  = true
    //
  },
};
</script>



// WEBPACK FOOTER //
// CovidReliefFeedbackResultModal.vue?7b673086